export default "__VITE_ASSET__CDzWnNZq__"